import { Professione } from '@hm_app/@core/models/dettaglio_profilo';
import { Injectable, Type } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable()
export class ProfessioneService {

    // Observable sources
    private professione = new BehaviorSubject<Professione>(null);

    // Observable streams
    professioneObservable = this.professione.asObservable();

    // Service message commands
    passProfessione(professione: Professione) {
        this.professione.next(professione);
    }
}
